module.exports = __webpack_public_path__ + "img/docker.6256521.svg";